import { GoogleMap } from "../../locations/GoogleMap";
import { GoogleMapMarker } from "../../locations/GoogleMapMarker";
import "./EldMessageLocationField.css";

interface Props {
  label?: string;
  location?: {
    [key: string]: string;
  } | null;
}

export const EldMessageLocationField = ({ location }: Props) => {
  if (!location) {
    return null;
  }

  const { LAT_DEGREES: lat, LON_DEGREES: lng } = location;
  if (!lat || !lng) {
    return null;
  }

  const latValue = Number(lat);
  const lngValue = Number(lng);
  if (isNaN(latValue) || isNaN(lngValue)) {
    return null;
  }

  return (
    <div className="eld-message-map">
      <GoogleMap fullscreenControl={false} defaultZoomLevel={7}>
        <GoogleMapMarker
          lat={latValue}
          lng={lngValue}
          iconPath="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
        />
      </GoogleMap>
    </div>
  );
};
